<template>
  <div>
    <snackbar-comp :SnackbarComponent="SnackbarComponent"></snackbar-comp>
    <v-dialog
      density="compact"
      v-model="internalDialog"
      :max-width="800"
      persistent
    >
      <v-card class="rounded-lg d-flex flex-column" height="95vh">
        <v-card-title
          class="d-flex align-center bg-primary text-white pa-2 text-subtitle-1 font-weight-bold flex-shrink-0"
        >
          <v-icon class="mr-2" size="small"
            >mdi-clipboard-text-play-outline</v-icon
          >
          Review Poll Creation Request

          <v-chip
            size="x-small"
            :color="
              request?.workflow_status === 'PENDING'
                ? 'warning'
                : request?.workflow_status === 'APPROVED'
                ? 'success'
                : 'error'
            "
            class="font-weight-bold text-uppercase ml-3 bg-white"
            variant="flat"
          >
            {{ request?.workflow_status }}
          </v-chip>

          <v-spacer></v-spacer>
          <v-btn variant="text" size="small" icon @click="closeDialog">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-3 flex-grow-1 overflow-y-auto">
          <v-form ref="pollForm">
            <v-row density="compact">
              <v-col cols="12" md="12" sm="12" class="py-1 mt-1">
                <v-text-field
                  v-model="formData.title"
                  label="Poll Question *"
                  density="compact"
                  variant="outlined"
                  :rules="[required]"
                  :hide-details="false"
                  prepend-inner-icon="mdi-help-circle"
                  counter="100"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  maxlength="100"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="12" sm="12" class="py-0">
                <v-row density="compact" class="d-flex align-center">
                  <v-col
                    cols="6"
                    sm="4"
                    md="3"
                    v-for="(option, index) in formData.options"
                    :key="index"
                    class="py-1"
                  >
                    <v-text-field
                      v-model="formData.options[index]"
                      :label="`Option ${index + 1}`"
                      density="compact"
                      maxlength="35"
                      :disabled="request?.workflow_status !== 'PENDING'"
                      counter
                      variant="outlined"
                      :rules="[(v) => !!v || 'Empty']"
                    >
                      <template v-slot:append-inner>
                        <v-icon
                          v-if="formData.options.length > 2"
                          color="error"
                          size="small"
                          class="cursor-pointer"
                          @click="removeOption(index)"
                          >mdi-close</v-icon
                        >
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" sm="4" md="3" class="mb-6">
                    <v-btn
                      variant="tonal"
                      color="primary"
                      prepend-icon="mdi-plus"
                      v-if="request?.workflow_status === 'PENDING'"
                      :disabled="formData.options.length >= 5"
                      @click="addOption"
                      >Add Option</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>

              <!-- <v-col cols="12" sm="6" class="pt-3">
                <v-select
                  v-model="formData.category"
                  :items="categories"
                  label="Category *"
                  density="compact"
                  variant="outlined"
                  hide-details="auto"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  :rules="[(v) => !!v || 'Required']"
                  prepend-inner-icon="mdi-shape"
                ></v-select>
              </v-col> -->
              <v-col cols="12" sm="6" class="pt-3">
                <v-select
                  v-model="formData.age_group"
                  :items="['18-30', '30-50', '50+', 'ALL']"
                  label="Age Group *"
                  density="compact"
                  variant="outlined"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  hide-details="auto"
                  :rules="[(v) => !!v || 'Required']"
                  prepend-inner-icon="mdi-account-group"
                ></v-select>
              </v-col>
            </v-row>

            <v-row density="compact" class="rounded mx-0 px-0 ml-n3">
              <v-col cols="6" sm="3" class="py-3">
                <v-autocomplete
                  v-model="selectedCountry"
                  label="Country"
                  :items="['ALL', 'India', 'United States']"
                  density="compact"
                  variant="outlined"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  hide-details="auto"
                  @update:modelValue="onCountryChange"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                v-if="selectedCountry !== 'ALL'"
                class="py-3"
              >
                <v-autocomplete
                  v-model="selectedState"
                  label="State"
                  :items="['ALL', ...availableStates]"
                  density="compact"
                  variant="outlined"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  hide-details="auto"
                  @update:modelValue="onStateChange"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                v-if="selectedCountry !== 'ALL' && selectedState !== 'ALL'"
                class="py-1"
              >
                <v-autocomplete
                  v-model="selectedDistrict"
                  label="District"
                  :items="['ALL', ...availableDistricts]"
                  density="compact"
                  variant="outlined"
                  hide-details="auto"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  @update:modelValue="onDistrictChange"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                v-if="
                  selectedCountry !== 'ALL' &&
                  selectedState !== 'ALL' &&
                  selectedDistrict !== 'ALL'
                "
                class="py-1"
              >
                <v-autocomplete
                  v-model="selectedPincode"
                  label="Pincode"
                  :items="['ALL', ...availablePincodes]"
                  density="compact"
                  variant="outlined"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row density="compact" class="mt-4">
              <v-col cols="12" sm="8" class="py-1">
                <v-menu
                  v-model="startDateTimeMenu"
                  :close-on-content-click="false"
                  offset-y
                  eager
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      v-bind="props"
                      :value="
                        formatDateTime(formData.startDate, formData.start_time)
                      "
                      placeholder="Poll Start Date & Time *"
                      density="compact"
                      variant="outlined"
                      hide-details="auto"
                      :disabled="request?.workflow_status !== 'PENDING'"
                      prepend-inner-icon="mdi-calendar-clock"
                      readonly
                      :rules="[
                        () =>
                          formData.startDate && formData.start_time
                            ? true
                            : 'Required',
                      ]"
                    ></v-text-field>
                  </template>

                  <v-card class="pa-2 pb-0">
                    <v-row class="my-0 py-0" density="compact">
                      <v-col cols="12" sm="6" class="pa-1">
                        <div
                          class="text-caption font-weight-bold mb-1 text-center"
                        >
                          Start Date
                        </div>
                        <v-date-picker
                          v-model="formData.startDate"
                          density="compact"
                          color="primary"
                          class="custom-date-picker w-100"
                        ></v-date-picker>
                      </v-col>
                      <v-col cols="12" sm="6" class="pa-1">
                        <div
                          class="text-caption font-weight-bold mb-1 text-center"
                        >
                          Start Time
                        </div>
                        <v-time-picker
                          v-model="formData.start_time"
                          density="compact"
                          format="ampm"
                          ampm-in-title
                          color="primary"
                          class="custom-time-picker w-100"
                        ></v-time-picker>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <div class="d-flex justify-end gap-2 px-2 pb-1">
                      <v-btn
                        variant="outlined"
                        size="small"
                        @click="clearDateTime"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        variant="flat"
                        size="small"
                        :disabled="!formData.startDate || !formData.start_time"
                        @click="startDateTimeMenu = false"
                        class="btn-primary-gradient"
                        >Confirm</v-btn
                      >
                    </div>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-autocomplete
                  v-model="formData.pollEnsIn"
                  :items="durationOptions"
                  label="Poll Duration *"
                  density="compact"
                  variant="outlined"
                  hide-details="auto"
                  :disabled="request?.workflow_status !== 'PENDING'"
                  prepend-inner-icon="mdi-timer-outline"
                  :rules="[() => (formData.pollEnsIn ? true : 'Required')]"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mt-0"></v-divider>

        <v-card-actions class="pa-3 bg-grey-lighten-5 flex-shrink-0">
          <v-spacer></v-spacer>
          <v-btn
            variant="plain"
            size="small"
            class="px-3 text-none"
            @click="closeDialog"
            >Cancel</v-btn
          >

          <template v-if="request?.workflow_status === 'PENDING'">
            <v-btn
              color="error"
              variant="outlined"
              prepend-icon="mdi-close-circle"
              size="small"
              class="text-none px-4"
              :loading="loadingReject"
              @click="handleApproveReject('REJECT')"
            >
              Reject Request
            </v-btn>
            <v-btn
              class="px-4 ml-2 text-none"
              color="green"
              prepend-icon="mdi-check-circle"
              size="small"
              :loading="loadingApprove"
              variant="flat"
              @click="handleApproveReject('APPROVE')"
            >
              Approve & Publish
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { approveOrRejectPollCreationWorkFlow } from "@/graphql/mutations";
import SnackbarComp from "@/components/Extras/SnackbarComp.vue";
import { generateClient } from "aws-amplify/api";

const client = generateClient();
export default {
  name: "PollRequestDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      default: null,
    },
    internalPincodes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SnackbarComp,
  },
  model: {
    prop: "dialog",
    event: "update:dialog",
  },
  emits: ["update:dialog", "approve", "reject"],
  data() {
    return {
      loadingApprove: false,
      loadingReject: false,
      startDateTimeMenu: false,

      selectedCountry: "ALL",
      selectedState: "ALL",
      selectedDistrict: "ALL",
      selectedPincode: "ALL",

      // Generate 1 to 72 hours just in case
      durationOptions: Array.from({ length: 72 }, (_, i) => `${i + 1} hours`),

      formData: {
        title: "",
        options: ["", ""],
        category: "",
        age_group: "ALL",
        startDate: new Date(),
        start_time: null,
        pollEnsIn: "24 hours",
      },
      categories: [
        "Technology",
        "Politics",
        "Sports",
        "Entertainment",
        "Business",
        "Health",
        "Lifestyle",
        "Society",
        "Education",
        "Travel",
        "Others",
      ],
      required: (value) => !!value || "Required",
      SnackbarComponent: {
        SnackbarVmodel: false,
        SnackbarText: "",
        SnackbarColor: "success",
      },
    };
  },
  computed: {
    internalDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("update:dialog", val);
      },
    },
    availableStates() {
      if (!this.internalPincodes || this.selectedCountry === "ALL") return [];

      const states = new Set(
        this.internalPincodes
          // Filter by the selected country first!
          .filter((item) => item.Country === this.selectedCountry)
          .map((item) => item.StateName),
      );
      return Array.from(states).filter(Boolean).sort();
    },
    availableDistricts() {
      if (!this.internalPincodes || this.selectedState === "ALL") return [];
      const districts = new Set(
        this.internalPincodes
          .filter((item) => item.StateName === this.selectedState)
          .map((item) => item.District),
      );
      return Array.from(districts).filter(Boolean).sort();
    },
    availablePincodes() {
      if (!this.internalPincodes || this.selectedDistrict === "ALL") return [];
      const pincodes = new Set(
        this.internalPincodes
          .filter(
            (item) =>
              item.District === this.selectedDistrict &&
              item.StateName === this.selectedState,
          )
          .map((item) => item.Pincode),
      );
      return Array.from(pincodes).filter(Boolean).sort();
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.request) {
        this.hydrateFormData();
      } else if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    hydrateFormData() {
      this.$nextTick(() => {
        let initialDate = new Date();
        let initialTimeStr = this.getCurrentTime();
        let pollDuration = "24 hours";

        // 1. Process Start Date & Time
        if (this.request.start_time) {
          const parsedDate = new Date(this.request.start_time);
          initialDate = parsedDate;
          const hrs = String(parsedDate.getHours()).padStart(2, "0");
          const mins = String(parsedDate.getMinutes()).padStart(2, "0");
          initialTimeStr = `${hrs}:${mins}`;

          // 2. Process End Time to calculate Duration
          if (this.request.end_time) {
            const diffMs = this.request.end_time - this.request.start_time;
            const diffHrs = Math.round(diffMs / (1000 * 60 * 60));
            pollDuration = `${diffHrs > 0 ? diffHrs : 24} hours`;

            // Ensure the option exists in the dropdown list
            if (!this.durationOptions.includes(pollDuration)) {
              this.durationOptions.push(pollDuration);
            }
          }
        }

        // 3. Map Core Fields
        this.formData = {
          title: this.request.title || "",
          options: this.request.options
            ? this.request.options.map((opt) => opt.text)
            : ["", ""],
          category: this.request.category || "",
          age_group: this.request.age_group || "ALL",
          startDate: initialDate,
          start_time: initialTimeStr,
          pollEnsIn: pollDuration,
        };

        // 4. Map Geographic Hierarchy
        const tType = this.request.target_type || "GLOBAL";
        const tVal = this.request.target_value || "GLOBAL";

        this.selectedCountry = "ALL";
        this.selectedState = "ALL";
        this.selectedDistrict = "ALL";
        this.selectedPincode = "ALL";

        if (tType === "COUNTRY") {
          this.selectedCountry = tVal;
        } else if (tType === "STATE") {
          this.selectedCountry = "INDIA";
          this.selectedState = tVal;
        } else if (tType === "DISTRICT") {
          this.selectedCountry = "INDIA";
          const loc = this.internalPincodes.find((p) => p.District === tVal);
          if (loc) this.selectedState = loc.StateName;
          this.selectedDistrict = tVal;
        } else if (tType === "PINCODE") {
          this.selectedCountry = "INDIA";
          const loc = this.internalPincodes.find((p) => p.Pincode === tVal);
          if (loc) {
            this.selectedState = loc.StateName;
            this.selectedDistrict = loc.District;
          }
          this.selectedPincode = tVal;
        }
      });
    },
    onCountryChange() {
      this.selectedState = "ALL";
      this.selectedDistrict = "ALL";
      this.selectedPincode = "ALL";
    },
    onStateChange() {
      this.selectedDistrict = "ALL";
      this.selectedPincode = "ALL";
    },
    onDistrictChange() {
      this.selectedPincode = "ALL";
    },
    getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    clearDateTime() {
      this.formData.startDate = null;
      this.formData.start_time = null;
      this.startDateTimeMenu = false;
    },
    formatDateTime(date, time) {
      if (!date || !time) return "";
      if (typeof time !== "string") return "";
      if (!time.includes(":")) return "";

      const dateObj = date instanceof Date ? date : new Date(date);
      let hours = 0;
      let minutes = 0;

      if (time.includes("AM") || time.includes("PM")) {
        let [timePart, modifier] = time.split(" ");
        let [h, m] = timePart.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
        if (modifier === "PM" && hours !== 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;
      } else {
        let [h, m] = time.split(":");
        hours = parseInt(h);
        minutes = parseInt(m);
      }

      const timeObj = new Date(dateObj);
      timeObj.setHours(hours, minutes);

      return `${dateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })} at ${timeObj.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })}`;
    },
    resolveTargetPayload() {
      let type = "GLOBAL";
      let value = "GLOBAL";
      if (this.selectedCountry !== "ALL") {
        type = "COUNTRY";
        value = this.selectedCountry;
        if (this.selectedState !== "ALL") {
          type = "STATE";
          value = this.selectedState;
          if (this.selectedDistrict !== "ALL") {
            type = "DISTRICT";
            value = this.selectedDistrict;
            if (this.selectedPincode !== "ALL") {
              type = "PINCODE";
              value = this.selectedPincode;
            }
          }
        }
      }
      return { target_type: type, target_value: value };
    },
    async handleApproveReject(action) {
      let updatedPollData = {};
      if (action === "APPROVE") {
        this.loadingApprove = true;
        const { valid } = await this.$refs.pollForm.validate();
        if (!valid) return;
        const startDateTime = new Date(this.formData.startDate);
        let timeStr = this.formData.start_time;
        let hours = 0,
          minutes = 0;
        if (timeStr.includes("AM") || timeStr.includes("PM")) {
          let [timePart, modifier] = timeStr.split(" ");
          let [h, m] = timePart.split(":");
          hours = parseInt(h);
          minutes = parseInt(m);
          if (modifier === "PM" && hours !== 12) hours += 12;
          if (modifier === "AM" && hours === 12) hours = 0;
        } else {
          let [h, m] = timeStr.split(":");
          hours = parseInt(h);
          minutes = parseInt(m);
        }
        startDateTime.setHours(hours, minutes, 0, 0);
        const startEpoch = startDateTime.getTime();

        // Calculate Epoch End
        const hoursToAdd = parseInt(this.formData.pollEnsIn.split(" ")[0]);
        const endEpoch = startEpoch + hoursToAdd * 60 * 60 * 1000;

        // Format Options
        let formOptions = [];
        this.formData.options.forEach((opt, ind) => {
          formOptions.push({ optionId: `opt_${ind + 1}`, text: opt });
        });

        const targetData = this.resolveTargetPayload();

        // Rebuild the final corrected payload
        updatedPollData = {
          workflow_id: this.request.workflow_id,
          title: this.formData.title,
          options: formOptions,
          target_type: targetData.target_type,
          target_value: targetData.target_value,
          age_group: this.formData.age_group,
          start_time: startEpoch,
          end_time: endEpoch,
          // category: this.formData.category,
        };
      } else {
        this.loadingReject = true;
      }
      updatedPollData.action_type = action;
      (updatedPollData.user_id =
        this.$store.getters.get_current_user_details.user_id),
        (updatedPollData.workflow_id = this.request.workflow_id);
      try {
        let result = await client.graphql({
          query: approveOrRejectPollCreationWorkFlow,
          variables: {
            input: {
              ...updatedPollData,
            },
          },
        });

        var ResultObj = JSON.parse(
          result.data.approveOrRejectPollCreationWorkFlow,
        );
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.SnackbarComponent = {
            SnackbarVmodel: true,
            SnackbarText: ResultObj.status_message,
            SnackbarColor: "success",
          };
          this.$emit("clicked", 2);
          this.closeDialog();
        }
        this.loadingApprove = false;
        this.loadingReject = false;
      } catch (error) {
        this.loadingApprove = false;
        this.loadingReject = false;
        console.log("Error", error);
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarText:
            error.errors?.[0]?.message ||
            "An error occurred. Please try again.",
          SnackbarColor: "error",
        };
        this.closeDialog();
      }
    },
    handleReject() {
      this.$emit("reject", this.request.workflow_id);
    },
    addOption() {
      this.formData.options.push("");
    },
    removeOption(index) {
      if (this.formData.options.length > 2) {
        this.formData.options.splice(index, 1);
      }
    },
    closeDialog() {
      this.internalDialog = false;
    },
    resetForm() {
      this.$nextTick(() => {
        if (this.$refs.pollForm) this.$refs.pollForm.resetValidation();
        this.formData = {
          title: "",
          options: ["", ""],
          category: "",
          age_group: "ALL",
          startDate: new Date(),
          start_time: this.getCurrentTime(),
          pollEnsIn: "24 hours",
        };
        this.selectedCountry = "ALL";
        this.selectedState = "ALL";
        this.selectedDistrict = "ALL";
        this.selectedPincode = "ALL";
      });
    },
  },
};
</script>

<style scoped>
.btn-primary-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}
.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.custom-date-picker :deep(.v-date-picker) {
  background: transparent !important;
}

.custom-date-picker :deep(.v-date-picker__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.custom-date-picker :deep(.v-date-picker-header__month),
.custom-date-picker :deep(.v-date-picker-header__year) {
  color: white !important;
}

.custom-date-picker :deep(.v-btn.v-btn--active) {
  color: white !important;
  background-color: #667eea !important;
}

.custom-time-picker :deep(.v-time-picker) {
  background: transparent !important;
}

.custom-time-picker :deep(.v-time-picker__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}

.custom-time-picker :deep(.v-time-picker__clock) {
  border-color: #667eea !important;
}

.custom-time-picker :deep(.v-time-picker-clock__needle),
.custom-time-picker :deep(.v-time-picker-clock__hand) {
  background-color: #667eea !important;
}

.cursor-pointer {
  cursor: pointer;
}

.gap-2 {
  gap: 8px;
}
</style>
